import { render, staticRenderFns } from "./SoftwareOfferDescriptionModal.vue?vue&type=template&id=c6ce2f8c&scoped=true&"
import script from "./SoftwareOfferDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./SoftwareOfferDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareOfferDescriptionModal.vue?vue&type=style&index=0&id=c6ce2f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce2f8c",
  null
  
)

export default component.exports